import { BaseComponent } from '../base-component.js';

export class AgButtonGroup extends BaseComponent {


  static observedAttributes = ["alignment"];

  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-button-group ${this.getAttribute('alignment') || ""}"><slot></slot></div>`;
  }
}

customElements.define('ag-button-group', AgButtonGroup);
